import axios from "axios";

export default {
    actions: {
        async authStep1(ctx, { mobile, isForgot, tried }) {
            const retried = ctx.state.user.retried;
            let data = {
                mobile: mobile,
                lang: ctx.state.lang,
                is_forgot: isForgot,
                tried:tried??1
            }
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/step_first", data)
                        .then(res => {
                            return res;
                        });
                })
                .catch(err => {
                    return err;
                });
            return res;
        },

        async checkOtp(ctx, { mobile, otp }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/step_check", {
                            phone: mobile,
                            otp: otp
                        })
                        .then(res => {
                            return res;
                        });
                })
                .catch(err => {
                    console.error(err);
                });
            return res;
        },

        async register(ctx, { mobile, userName, password, confirmPassword }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/register2", {
                            phone: mobile,
                            name: userName,
                            password: password,
                            password_confirmation: confirmPassword
                        })
                        .then(res => {
                            ctx.commit("updateIsRegistered", true);
                            return res;
                        });
                })
                .catch(err => console.error(err));
            return res;
        },

        async resetPassword(ctx, { mobile, password, confirmPassword }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/reset2", {
                            phone: mobile,
                            password: password,
                            password_confirmation: confirmPassword
                        })
                        .then(res => {
                            ctx.commit("updateIsRegistered", true);
                            return res;
                        });
                })
                .catch(err => console.error(err));
            return res;
        },

        async authLogin(ctx, { mobile, password }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/step_login2", {
                            phone: mobile,
                            password: password
                        })
                        .then(res => {
                            ctx.commit("updateIsRegistered", true);
                            return res;
                        });
                })
                .catch(err => {
                    return err;
                });
            return res;
        },

        async authLogOut(ctx) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios.get("/sanctum/csrf-cookie").then(response => {
                        return axios.post("/api/auth/logout").then(res => {
                            ctx.commit("updateIsRegistered", false);
                            return res;
                        });
                    });
                })
                .catch(err => {
                    return err;
                });
            return res;
        },

        async getUserInfo(ctx) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios.get("/api/auth/user").then(res => res);
                })
                .catch(err => {
                    return err;
                });
            ctx.commit("updateUserInfo", res.data.data);
            return res;
        },

        async getUserInfoSecond(ctx) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios.get("/api/user3").then(res => res);
                })
                .catch(err => {
                    return err;
                });
            ctx.commit("updateUserInfo", res.data.data);
            return res;
        },

        async getRegions(ctx) {
            const res = await axios
                .post("/api/guide/regionsBts")
                .then(res => res)
                .catch(err => err);
            const data = res.data.data;
            ctx.commit("updateRegions", data);
        },

        async getProvinces(ctx, regionCode = null) {
            if (!regionCode) {
                ctx.commit("updateProvinces", []);
                return;
            }

            const res = await axios
                .post("/api/guide/provincesBts", { regionCode })
                .then(res => res)
                .catch(err => err);
            const data = res.data.data;
            ctx.commit("updateProvinces", data);
        },

        async juridicAuthStep1(ctx, { phone, inn }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/juridic/step_1", {
                            phone: phone,
                            inn: inn
                        })
                        .then(res => {
                            return res;
                        });
                })
                .catch(err => {
                    return err;
                });
            return res;
        },

        async juridicAuthStepSecond(ctx, data) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/juridic/step_2", {
                            ...data
                        })
                        .then(res => {
                            return res;
                        });
                })
                .catch(err => {
                    return err;
                });
            return res;
        },

        async juridicCheckOtp(ctx, { mobile, otp }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/juridic/step_3", {
                            phone: mobile,
                            otp: otp
                        })
                        .then(res => {
                            return res;
                        });
                })
                .catch(err => {
                    console.error(err);
                });
            return res;
        },

        async juridicRegister(ctx, { mobile, inn, password, confirmPassword }) {
            const res = await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .post("/api/auth/juridic/step_42", {
                            phone: mobile,
                            inn,
                            password: password,
                            password_confirmation: confirmPassword
                        })
                        .then(res => {
                            ctx.commit("updateIsRegistered", true);
                            return res;
                        });
                })
                .catch(err => console.error(err));
            return res;
        }
    },

    mutations: {
        updateIsRegistered(state, foo) {
            state.isRegistered = foo;
        },

        updateMessage(state, foo) {
            state.msg = foo;
        },

        updateIsForgot(state, foo) {
            state.isForgot = foo;
        },

        updateStage(state, foo) {
            state.stage = foo;
        },

        updateLang(state, foo) {
            state.lang = foo;
        },

        updateAuthBlock(state, foo) {
            state.authBlock = foo;
        },

        updateFifths(state, foo) {
            state.triedFifths = foo;
        },

        updatePhone(state, foo) {
            state.user.phone = foo;
        },

        updateRetried(state, foo) {
            state.user.retried = foo;
        },

        updatePhoneSelected(state, foo) {
            state.user.phoneSelected = foo;
        },

        updateUserInfo(state, foo) {
            state.userInfo = foo;
        },

        updateRegions(state, foo) {
            state.allRegions = foo;
        },

        updateProvinces(state, foo) {
            state.allProvinces = foo;
        },

        resetUserInfo(state) {
            state.userInfo = {};
        }
    },

    state() {
        return {
            isRegistered: false,
            msg: "",
            isForgot: 0,
            stage: "",
            lang: "ru",
            authBlock: false,
            triedFifths: false,
            user: {
                phone: "",
                retried: false
            },
            phoneSelected: false,
            userInfo: {},

            allRegions: [],
            allProvinces: []
        };
    },

    getters: {
        isRegistered(state) {
            return state.isRegistered;
        },
        message(state) {
            return state.msg;
        },
        isForgot(state) {
            return state.isForgot;
        },
        stage(state) {
            return state.stage;
        },
        lang(state) {
            return state.lang;
        },

        authBlock(state) {
            return state.authBlock;
        },

        triedFifths(state) {
            return state.triedFifths;
        },

        userPhone(state) {
            return state.user.phone;
        },

        userRetried(state) {
            return state.user.retried;
        },
        phoneSelected(state) {
            return state.phoneSelected;
        },

        userInfo(state) {
            return state.userInfo;
        },

        allRegions(state) {
            return state.allRegions;
        },

        allProvinces(state) {
            return state.allProvinces;
        }
    }
};
